import React from "react";
import "./Services.scss";

const Services = ({ data, title }) => {
  if (!data || data.length === 0) return null;

  return (
    <section className="services-benefits-section">
      <span className="subtitle">{title}</span>
      <h2 className="benefits-title">Key Benefits</h2>

      <div className="benefits-container">
        <div className="benefits-grid" style={{ "--items-count": data.length }}>
          {data.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <span
                className={`card-dot ${index % 2 === 0 ? "orange" : "blue"}`}
              ></span>
              <div className="icon-placeholder">
                {benefit.icon ? (
                  <img src={benefit.icon} alt="benefit icon" />
                ) : (
                  <div className="css-icon-placeholder"></div>
                )}
              </div>
              <p className="benefit-text">
                {typeof benefit === "string" ? benefit : benefit.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
